import {
  FaFileInvoiceDollar,
  FaChartLine,
  FaBoxes,
  FaCog,
  FaClipboardList,
  FaRulerCombined,
  FaFileContract,
  FaUsers,
  FaWallet,
  FaRegFileAlt,
  FaBuilding,
  FaHome,
  FaProjectDiagram,
  FaHandHoldingUsd,
  FaMoneyBillWave,
  FaShoppingCart,
  FaTruck
} from 'react-icons/fa';

export const MAIN_SECTIONS = [
  {
    id: 'billing',
    label: 'Billing',
    icon: FaFileInvoiceDollar,
    path: '/bills',
    status: 'active'
  },
  {
    id: 'financials',
    label: 'Financials',
    icon: FaChartLine,
    path: '/financials',
    status: 'active'
  },
  {
    id: 'inventory',
    label: 'Inventory',
    icon: FaBoxes,
    path: null,
    status: 'coming-soon'
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: FaCog,
    path: '/admin',
    status: 'active'
  }
];

export const BILLING_NAV_ITEMS = [
  { to: '/bills', label: 'Invoice', icon: FaFileInvoiceDollar, match: ['/bills', '/createBill'] },
  { to: '/demoBills', label: 'Proforma Invoice', icon: FaRegFileAlt, match: ['/demoBills', '/createDemoBill'] },
  { to: '/measureSheet', label: 'Measure Sheet', icon: FaRulerCombined, match: ['/measureSheet', '/createMeasureSheet'] },
  { to: '/quotations', label: 'Quotations', icon: FaFileContract, match: ['/quotations', '/createQuotations'] },
  { to: '/terms-and-conditions', label: 'Terms & Conditions', icon: FaClipboardList, match: ['/terms-and-conditions'] }
];

export const FINANCIALS_NAV_ITEMS = [
  { to: '/financials', label: 'Reports', icon: FaChartLine, match: ['/financials'], exact: true },
  { to: '/financials/client-reports', label: 'Client Reports', icon: FaUsers, match: ['/financials/client-reports'] },
  { to: '/ledgerClients', label: 'Ledgers', icon: FaWallet, match: ['/ledgerClients', '/ledgerDetails'] },
  { to: '/financials/income', label: 'Income', icon: FaHandHoldingUsd, match: ['/financials/income', '/createIncome'] },
  { to: '/financials/expense', label: 'Expense', icon: FaMoneyBillWave, match: ['/financials/expense', '/createExpense'] },
  { to: '/financials/purchase', label: 'Purchase', icon: FaShoppingCart, match: ['/financials/purchase', '/createPurchase'] }
];

export const ADMIN_NAV_ITEMS = [
  { to: '/admin/companies', label: 'Companies', icon: FaBuilding, match: ['/admin/companies', '/createCompany'] },
  { to: '/clients', label: 'Clients', icon: FaUsers, match: ['/clients', '/createClient'] },
  { to: '/admin/projects', label: 'Projects', icon: FaProjectDiagram, match: ['/admin/projects', '/createProject'] },
  { to: '/admin/vendors', label: 'Vendors', icon: FaTruck, match: ['/admin/vendors', '/createVendor', '/admin/vendor-types', '/createVendorType'] }
];

export const SECTION_NAV = [
  {
    id: 'billing',
    label: 'Billing',
    icon: FaFileInvoiceDollar,
    path: '/bills',
    status: 'active',
    items: BILLING_NAV_ITEMS
  },
  {
    id: 'financials',
    label: 'Financials',
    icon: FaChartLine,
    path: '/financials',
    status: 'active',
    items: FINANCIALS_NAV_ITEMS
  },
  {
    id: 'inventory',
    label: 'Inventory',
    icon: FaBoxes,
    path: null,
    status: 'coming-soon',
    items: []
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: FaCog,
    path: '/admin',
    status: 'active',
    items: ADMIN_NAV_ITEMS
  }
];

const BILLING_PREFIXES = [
  '/bills',
  '/demoBills',
  '/measureSheet',
  '/quotations',
  '/terms-and-conditions',
  '/createBill',
  '/createDemoBill',
  '/createMeasureSheet',
  '/createQuotations'
];

const FINANCIALS_PREFIXES = ['/financials', '/ledgerClients', '/ledgerDetails', '/createIncome', '/createExpense', '/createPurchase'];

const ADMIN_PREFIXES = ['/admin', '/createCompany', '/clients', '/createClient', '/admin/projects', '/createProject', '/admin/vendors', '/createVendor', '/admin/vendor-types', '/createVendorType'];

export function matchesPath(pathname, prefixes) {
  return prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function getNavContext(pathname) {
  if (pathname === '/home') {
    return 'dashboard';
  }
  if (matchesPath(pathname, ADMIN_PREFIXES)) {
    return 'admin';
  }
  if (matchesPath(pathname, FINANCIALS_PREFIXES)) {
    return 'financials';
  }
  if (matchesPath(pathname, BILLING_PREFIXES)) {
    return 'billing';
  }
  return 'dashboard';
}

export function isNavItemActive(pathname, matchPrefixes, exact = false) {
  if (exact) {
    return matchPrefixes.some((prefix) => pathname === prefix);
  }
  return matchesPath(pathname, matchPrefixes);
}

export const DASHBOARD_LINK = {
  to: '/home',
  label: 'Dashboard',
  icon: FaHome
};

export const SECTION_LABELS = {
  dashboard: 'Dashboard',
  billing: 'Billing',
  admin: 'Admin',
  financials: 'Financials',
  inventory: 'Inventory'
};
